module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_05.d7a1b24b.jpg";